/**
 * Persiste fbclid (Meta) en sessionStorage y lo añade a todos los enlaces whop.com.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'clashivfx_whop_fbclid';

  function getFbclidFromLocation() {
    try {
      var u = new URL(window.location.href);
      var v = u.searchParams.get('fbclid');
      return v && String(v).trim() ? String(v).trim() : '';
    } catch (e) {
      return '';
    }
  }

  /** Prioridad: fbclid en la URL actual; si no, valor guardado en la sesión. */
  function resolveFbclid() {
    var fromUrl = getFbclidFromLocation();
    if (fromUrl) {
      try {
        sessionStorage.setItem(STORAGE_KEY, fromUrl);
      } catch (e) {}
      return fromUrl;
    }
    try {
      return sessionStorage.getItem(STORAGE_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function isWhopHost(hostname) {
    return hostname === 'whop.com' || hostname.slice(-9) === '.whop.com';
  }

  function applyFbclidToWhopAnchors(fbclid) {
    if (!fbclid) return;

    var anchors = document.querySelectorAll('a[href*="whop.com"]');
    for (var i = 0; i < anchors.length; i++) {
      var link = anchors[i];
      var raw = link.getAttribute('href');
      if (!raw || raw.charAt(0) === '#' || raw.toLowerCase().indexOf('javascript:') === 0) continue;

      try {
        var u = new URL(raw, window.location.href);
        if (!isWhopHost(u.hostname)) continue;
        u.searchParams.set('fbclid', fbclid);
        link.href = u.toString();
      } catch (e) {}
    }
  }

  /** Reaplica fbclid a enlaces Whop (p. ej. tras cambiar href en International payments dinámico). */
  function reapplyWhopFbclid() {
    applyFbclidToWhopAnchors(resolveFbclid());
  }

  window.clashivfxReapplyWhopFbclid = reapplyWhopFbclid;

  function init() {
    function run() {
      reapplyWhopFbclid();
    }

    run();
    setTimeout(run, 0);

    var debounceTimer;
    function scheduleReapply() {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(run, 50);
    }

    try {
      var mo = new MutationObserver(scheduleReapply);
      mo.observe(document.documentElement, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['href'],
      });
    } catch (e) {}

    document.addEventListener('shopify:section:load', scheduleReapply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
